<template>
  <div id="app-word">
    <form id="office_form" name="office_form" target="office_frame" action="" method="post">
      <input name="access_token" id="access_token" value="" type="hidden" />
      <input name="access_token_ttl" id="access_token_ttl" value="" type="hidden" />
    </form>
    <span id="frameholder"></span>
    <login ref="logincall"></login>
  </div>
</template>
<style scoped>
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  -ms-content-zooming: none;
}

#app-word {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#office_frame {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  border: none;
  display: block;
}

#frameholder {
  display: block;
  width: 100%;
  height: 100%;
}

iframe#office_frame {
  width: 100%;
  height: 100%;
  display: block;
}

.login_pop {
  top: 0;
}
</style>
<script>
import { getsharedfileeditinfo } from '@/services/Api'
import login from '@/components/Login'
import cookies from '@/services/cookies'

export default {
  components: {
    login
  },
  data() {
    return {

    }
  },
  methods: {
    logincall(reload) {
      this.$refs.logincall.load(reload)
    },
    reload() {
      window.location.reload()
    },
    load(url) {
      document.querySelector('#access_token').value = cookies.getCookie('token')

      document.querySelector('#access_token_ttl').value = Date.now() + 60 * 60 * 60 * 1000
      document.querySelector('#office_form').setAttribute('action', url)

      var frameholder = document.getElementById('frameholder')
      var office_frame = document.createElement('iframe')
      office_frame.name = 'office_frame'
      office_frame.id = 'office_frame'
      office_frame.style.width = '100%'
      office_frame.style.height = '100%'
      // The title should be set for accessibility
      office_frame.title = 'Office Frame'
      // This attribute allows true fullscreen mode in slideshow view
      // when using PowerPoint's 'view' action.
      office_frame.setAttribute('allowfullscreen', 'true')
      // The sandbox attribute is needed to allow automatic redirection to the O365 sign-in page in the business user flow
      office_frame.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox')
      frameholder.appendChild(office_frame)
      document.getElementById('office_form').submit()
    }
  },
  mounted() {
    let id = this.$route.params.file
    let data = {
      token: cookies.getCookie('token'),
      id: id,
      mode: 'view'
    }

    let that = this

    getsharedfileeditinfo(data).then(res => {
      if (res.data.data === true) {
        let link = document.querySelector("link[rel*='icon']")
        if (res.data.result === 'success') {
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = res.data.action.favIconUrl
          this.load(res.data.action.urlsrc)
        } else {
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = res.data.action.favIconUrl
          this.load(res.data.action.urlsrc)
        }
      } else {
        that.logincall(true)
        that.$router.push('/login')
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>
